class DefaultAsset {
  id = "";
  Type = "";
  Name = "";
  core = false;
  front = true;
  icon = "perspective-dice-six-faces-random";
  Abilities = [
    { Name: "", Text: "", Enabled: false },
    { Name: "", Text: "", Enabled: false },
    { Name: "", Text: "", Enabled: false },
  ];
  InputFields = [];
  Description = "";
  TrackMax = 0;
  TrackValue = 0;
  TrackLabels = [];
}
export default DefaultAsset;
